import { useBehavior } from '@libs/core';
import { TWidgetProps } from '@libs/types';
import React from 'react';
import { TSeparatorData } from '../../types/data';
import { TSeparatorOption } from '../../types/options';
import { SeparatorView } from './SeparatorView';

export const SeparatorWidget: React.FC<TWidgetProps<TSeparatorData, TSeparatorOption>> = ({ widget }) => {
    const { isHidden, isDisabled } = useBehavior(widget);

    const parentStyleNames = [widget.options?.style].filter(Boolean) as string[];

    return (
        <SeparatorView
            widget={widget}
            uid={widget.uid}
            variant={widget.options?.separatorVariant}
            hierarchy={widget.options?.separatorHierarchy}
            text={widget.data?.text}
            metaText={widget.data?.metaText}
            margin={widget.options?.margin}
            parentStyleNames={parentStyleNames}
            isHide={isHidden}
            isDisabled={isDisabled}
        />
    );
};
